"use strict";
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.initZpdesFromAdaptativeTest = exports.makeMultiGraphConfig = void 0;
var cloneDeep_1 = __importDefault(require("lodash/cloneDeep"));
var parametric_graph_1 = require("@evidenceb/parametric-graph");
var ai_toolkit_1 = require("@evidenceb/ai-toolkit");
/**
 * To manage several definition of the graph
 * Returns a dictionnary with the key corresponding to the
 * algo names, or labels of the different possible graphs
 * that can be loaded in the front for several AI instance
 * such as ZPDES, adaptive test, revision alg
 */
function makeMultiGraphConfig(baseConfig, moduleId) {
    var e_1, _a, _b, _c;
    var finalModuleConfig = Object({});
    var baseModuleConfig = baseConfig[moduleId];
    if (baseModuleConfig["graph_computation"]) {
        for (var alg in baseModuleConfig["graph_computation"]) {
            var algConfig = (0, cloneDeep_1.default)(baseModuleConfig);
            try {
                for (var _d = (e_1 = void 0, __values(baseModuleConfig["graph_computation"][alg]["list_not_relevant_actObjId"])), _e = _d.next(); !_e.done; _e = _d.next()) {
                    var objActToRemove = _e.value;
                    if (Object.keys(objActToRemove).includes("activityId")) {
                        suppress_element_in_graph(algConfig, objActToRemove["objectiveId"], objActToRemove["activityId"]);
                        var RequirementDeleteCriteria = {
                            targetId: objActToRemove["activityId"],
                            dim: objActToRemove["objectiveId"],
                            lvl: algConfig[objActToRemove["objectiveId"]].subgroups[0].indexOf(objActToRemove["activityId"]),
                        };
                        removeEntriesByCriteriaInModuleConfig(algConfig, RequirementDeleteCriteria);
                    }
                    else if (Object.keys(objActToRemove).includes("objectiveId")) {
                        suppress_element_in_graph(algConfig, moduleId, objActToRemove["objectiveId"]);
                        delete algConfig[objActToRemove["objectiveId"]];
                        var RequirementDeleteCriteria = {
                            targetId: objActToRemove["objectiveId"],
                            dim: moduleId,
                            lvl: algConfig[moduleId].subgroups[0].indexOf(objActToRemove["objectiveId"]),
                        };
                        removeEntriesByCriteriaInModuleConfig(algConfig, RequirementDeleteCriteria);
                    }
                    // else if (Object.keys(objActToRemove).includes("objectiveId")) {
                    //     suppress_element_in_graph(algConfig[moduleId], moduleId, objActToRemove["objectiveId"]);
                    //     delete algConfig[moduleId][objActToRemove["objectiveId"]];
                    // }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_e && !_e.done && (_a = _d.return)) _a.call(_d);
                }
                finally { if (e_1) throw e_1.error; }
            }
            finalModuleConfig[alg] = (_b = {}, _b[moduleId] = algConfig, _b);
        }
    }
    else {
        finalModuleConfig["zpdes"] = (_c = {}, _c[moduleId] = baseModuleConfig, _c);
    }
    return finalModuleConfig;
}
exports.makeMultiGraphConfig = makeMultiGraphConfig;
/**
 * subfuntion to supress an element in the graph, either objective or activity
 * @param moduleConfig config of a module
 * @param elementToRemoveSsbgID id of SSBG in which is the element needed to be supressed
 * @param elementToRemoveId id element needed to be supressed
 */
function suppress_element_in_graph(moduleConfig, elementToRemoveSsbgID, elementToRemoveId) {
    var indexElementToDelete = moduleConfig[elementToRemoveSsbgID]["subgroups"][0].indexOf(elementToRemoveId);
    if (indexElementToDelete > -1) {
        moduleConfig[elementToRemoveSsbgID]["subgroups"][0].splice(indexElementToDelete, 1);
        if (moduleConfig[elementToRemoveSsbgID]["init_ssb"][0].includes(indexElementToDelete)) {
            var indexOfElementInInitSsb = moduleConfig[elementToRemoveSsbgID]["init_ssb"][0].indexOf(indexElementToDelete);
            moduleConfig[elementToRemoveSsbgID]["init_ssb"][0].splice(indexOfElementInInitSsb, 1);
        }
        for (var index = 0; index < moduleConfig[elementToRemoveSsbgID]["init_ssb"][0].length; index++) {
            if (moduleConfig[elementToRemoveSsbgID]["init_ssb"][0][index] >
                indexElementToDelete) {
                moduleConfig[elementToRemoveSsbgID]["init_ssb"][0][index]--;
            }
        }
    }
}
function removeEntriesByCriteriaInModuleConfig(moduleConfig, criteria) {
    Object.keys(moduleConfig).forEach(function (topLevelKey) {
        var topLevelItem = moduleConfig[topLevelKey];
        if (typeof topLevelItem === "object" &&
            topLevelItem !== null &&
            topLevelItem.hasOwnProperty("dim_requirements")) {
            var mapped = topLevelItem.dim_requirements.map(function (reqContainer) {
                return removeEntriesFromDimRequirements(reqContainer, criteria);
            });
            var filtered = mapped.filter(function (container) { return container !== null; });
            topLevelItem.dim_requirements = filtered;
        }
    });
}
function removeEntriesFromDimRequirements(reqContainer, criteria) {
    var newReqContainer = {};
    var isEmpty = true;
    Object.keys(reqContainer).forEach(function (reqKey) {
        // Apply filtering based on targetId if provided
        if (!criteria.targetId || reqKey !== criteria.targetId) {
            var filteredReqs = reqContainer[reqKey].filter(function (req) {
                var meetsDimCriteria = criteria.dim ? req.dim !== criteria.dim : true;
                var meetsLvlCriteria = criteria.lvl ? req.lvl !== criteria.lvl : true;
                return meetsDimCriteria || meetsLvlCriteria;
            });
            if (filteredReqs.length > 0) {
                newReqContainer[reqKey] = filteredReqs;
                isEmpty = false;
            }
        }
    });
    return isEmpty ? [] : newReqContainer;
}
/**
 * TO DO : manage the case for init graph zpdes from adaptive test when graph are not the same
 */
/**
 * Funtion to manage connexion between result of adaptive test
 * and initialisation of zpdes graph
 * @param zpdesGraph
 * @param adaptiveTestOutput
 */
function initZpdesFromAdaptativeTest(zpdesGraph, adaptiveTestOutput) {
    var e_2, _a, e_3, _b;
    var parametricgraph = (0, parametric_graph_1.makeGraphFromData)(zpdesGraph, zpdesGraph.graph.graph.act_prime);
    var ontology = new ai_toolkit_1.Ontology(zpdesGraph);
    for (var objective in adaptiveTestOutput) {
        if (zpdesGraph.graph.graph[objective].ordered[0] == 1) {
            var branches_in_objectif = find_branches_in_objective(objective, zpdesGraph, parametricgraph);
            var activity_postion_in_obj = [];
            try {
                for (var _c = (e_2 = void 0, __values(Object.keys(branches_in_objectif))), _d = _c.next(); !_d.done; _d = _c.next()) {
                    var key = _d.value;
                    var activity_postion = [];
                    try {
                        //branches_in_objectif[key] = branches_in_objectif[key].reverse();
                        for (var _e = (e_3 = void 0, __values(branches_in_objectif[key])), _f = _e.next(); !_f.done; _f = _e.next()) {
                            var act = _f.value;
                            if (adaptiveTestOutput[objective][ontology.get_activity_position_in_obj(act)])
                                activity_postion.push(ontology.get_activity_position_in_obj(act));
                        }
                    }
                    catch (e_3_1) { e_3 = { error: e_3_1 }; }
                    finally {
                        try {
                            if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                        }
                        finally { if (e_3) throw e_3.error; }
                    }
                    activity_postion_in_obj.push(activity_postion.sort(function (a, b) { return a - b; }));
                    if (activity_postion.length) {
                        var maxMasteredIdx = Math.max(activity_postion.length - 2, 0);
                        for (var index_in_branch = 0; index_in_branch <= maxMasteredIdx; index_in_branch++) {
                            var actId = zpdesGraph.graph.graph[objective].subgroups[0][activity_postion[index_in_branch]];
                            var sr = zpdesGraph.graph.graph[objective].bandVal_deactZPDval[0][activity_postion[maxMasteredIdx]];
                            var act_sr = zpdesGraph.graph.graph[objective].bandVal_deactZPDval[0][activity_postion[index_in_branch]];
                            var linkedDeactReqFrom = {
                                dim: objective,
                                lvl: activity_postion[maxMasteredIdx],
                                sr: sr,
                                completed: 0,
                                nature: "sufficient",
                            };
                            var ownDeactRec = {
                                dim: objective,
                                lvl: activity_postion[index_in_branch],
                                sr: act_sr,
                                completed: 0,
                                nature: "sufficient",
                            };
                            if (!Object.keys(zpdesGraph.graph.graph[objective]).includes("deact_requirements")) {
                                zpdesGraph.graph.graph[objective]["deact_requirements"] = [{}];
                            }
                            if (actId in zpdesGraph.graph.graph[objective].deact_requirements[0]) {
                                zpdesGraph.graph.graph[objective].deact_requirements[0][actId].push(ownDeactRec);
                                zpdesGraph.graph.graph[objective].deact_requirements[0][actId].push(linkedDeactReqFrom);
                            }
                            else {
                                zpdesGraph.graph.graph[objective].deact_requirements[0][actId] = [
                                    linkedDeactReqFrom,
                                    ownDeactRec,
                                ];
                            }
                            if (!zpdesGraph.graph.graph[objective].init_ssb[0].includes(activity_postion[index_in_branch])) {
                                zpdesGraph.graph.graph[objective].init_ssb[0].push(activity_postion[index_in_branch]);
                            }
                        }
                    }
                }
            }
            catch (e_2_1) { e_2 = { error: e_2_1 }; }
            finally {
                try {
                    if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
                }
                finally { if (e_2) throw e_2.error; }
            }
            zpdesGraph.graph.graph[objective].mastered_act = [
                activity_postion_in_obj,
            ];
        }
    }
}
exports.initZpdesFromAdaptativeTest = initZpdesFromAdaptativeTest;
/**
 * subfunction to find branches in an objective to init ZPDES according to that
 * @param objId ID of the objective
 * @param zpdesGraph ZPDES graph
 * @param parametricgraph
 * @returns
 */
function find_branches_in_objective(objId, zpdesGraph, parametricgraph) {
    var branches = {};
    var activities = zpdesGraph.graph.graph[objId].subgroups[0];
    var seen = [];
    for (var i = activities.length - 1; i > 0; i--) {
        if (!seen.includes(activities[i])) {
            var ancestors = (0, parametric_graph_1.getAncestors)(parametricgraph, activities[i]);
            ancestors = ancestors.filter(function (x) { return activities.includes(x); });
            branches[activities[i]] = ancestors;
            seen = seen.concat(ancestors);
            if (ancestors.length == activities.length) {
                break;
            }
        }
    }
    return branches;
}
// function removeEntriesByCriteriaInModuleConfig(moduleConfig: Ifu, targetId: string) {
//     Object.keys(moduleConfig).forEach(topLevelKey => {
//         const topLevelItem = moduleConfig[topLevelKey];
//         if (typeof topLevelItem === 'object' && topLevelItem !== null && topLevelItem.hasOwnProperty('dim_requirements')) {
//             const mapped: (RequirementsContainer | null)[] = topLevelItem.dim_requirements.map(
//                 (reqContainer: RequirementsContainer) => removeEntriesFromDimRequirements(reqContainer, targetId)
//             );
//             const filtered: RequirementsContainer[] = mapped.filter((container): container is RequirementsContainer => container !== null);
//             topLevelItem.dim_requirements = filtered;
//         }
//     });
// }
// function removeEntriesFromDimRequirements(reqContainer: RequirementsContainer, targetId: string): RequirementsContainer | null {
//     const newReqContainer: RequirementsContainer = {};
//     let isEmpty = true;
//     Object.keys(reqContainer).forEach(reqKey => {
//         if (reqKey !== targetId) {
//             const filteredReqs = reqContainer[reqKey].filter(req => req.dim !== targetId);
//             if (filteredReqs.length > 0) {
//                 newReqContainer[reqKey] = filteredReqs;
//                 isEmpty = false;
//             }
//         }
//     });
//     return isEmpty ? null : newReqContainer;
// }
